module.exports = __webpack_public_path__ + "img/ic_head_hight_6.ac4a5498.png";